//
// DataUsage.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var DataUsage = {
    UNSPECIFIED:0,
    CATEGORICAL:1,
    QUANTITATIVE:2
};
export default DataUsage;
